import type { Workspace } from "$lib/core/types.js";

// A member's role in a workspace (null on Workspace.role = an external: no role).
export type WorkspaceRole = NonNullable<Workspace["role"]>;

// Owners and admins manage the workspace. The one owner-or-admin check; an external
// (no role) is never an admin.
export function isWorkspaceAdmin(role: WorkspaceRole | null | undefined): boolean {
  return role === "owner" || role === "admin";
}

// Who may configure webhooks: the server's `manage_webhooks` row, member and above. A
// channel-admin seat held below it (a member demoted to viewer keeps it) manages nothing.
export function canManageWebhooks(role: WorkspaceRole | null | undefined): boolean {
  return role === "owner" || role === "admin" || role === "member";
}

const ROLES: readonly string[] = ["owner", "admin", "member", "viewer"] satisfies WorkspaceRole[];
/** A roster row's role, when it is a real workspace role (null and unknown strings are not). */
export function isWorkspaceRole(role: string | null | undefined): role is WorkspaceRole {
  return !!role && ROLES.includes(role);
}
